<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6" v-for="address in addresses" :key="address.id">
        <v-card class="mb-4">
          <v-card-title>
            {{ $t('userAddress.recipient') }}: {{ address.firstName }} / {{ address.lastName }}[{{ address.fullName }} ]
          </v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item>
                <v-list-item>
                  <v-list-item-title>{{ $t('userAddress.phone') }}: {{ address.phoneNumber }}</v-list-item-title>
                </v-list-item>
              </v-list-item>
              <v-list-item>
                <v-list-item>
                  <v-list-item-title>{{ $t('userAddress.region') }}: {{ address.region }}</v-list-item-title>
                </v-list-item>
              </v-list-item>
              <v-list-item>
                <v-list-item>
                  <v-list-item-title>{{ $t('userAddress.detailedAddress') }}: {{ address.detailedAddress }}</v-list-item-title>
                </v-list-item>
              </v-list-item>
              <v-list-item>
                <v-list-item>
                  <v-list-item-title>{{ $t('userAddress.postalCode') }}: {{ address.postalCode }}</v-list-item-title>
                </v-list-item>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-btn icon @click="editAddress(address)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon @click="deleteAddress(address)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>


      <!-- 无数据时显示的默认排版 -->
      <v-col cols="12" v-if="addresses.length === 0">
        <v-card class="mb-4">
          <v-card-title>
            {{ $t('userAddress.noAddresses') }}
          </v-card-title>
          <v-card-text>
            <p>{{ $t('userAddress.addAddressPrompt') }}</p>
            <v-btn color="primary" @click="addNewAddress">
              {{ $t('userAddress.addAddress') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <AddressForm 
    :visible="isFormVisible" 
    :address="curentAddress" 
    @addressSaved="handleAddressSaved"  />
  </v-container>
</template>

<script>
import { fetchUserAddresses, deleteAddress, updateAddress, addAddress } from '@/api/apiService';
import AddressForm from '@/components/AddressForm.vue';

export default {
  name: 'UserAddress',
  data() {
    return {
      addresses: [],
      loading: false,
      isFormVisible: false,
      curentAddress: null,
    };
  },
  components: {
    AddressForm,
  },
  methods: {
    loadAddresses(page = 1) {
      this.loading = true;
      fetchUserAddresses(page).then(response => {
        const addressArray = response.data.data;
        if(Array.isArray(addressArray)){
          addressArray.map(item => {
            item.detailedAddress = item.country + "," + item.region + "," + item.street + "," + item.address 
          });
        }
        this.addresses = addressArray;
        this.loading = false;
        console.log(this.addresses, 'address this.addresses');
      });
    },
    addNewAddress() {
      this.isFormVisible = true;
      this.curentAddress = null;
    },
    editAddress(address) {
      this.isFormVisible = true;
      this.curentAddress = address;
    },
    deleteAddress(address) {
      deleteAddress(address.order_id).then(response => {
        console.log(response, 'address deleteAddress');
        if(response.status === 200){
          this.loadAddresses();
          this.addresses = this.addresses.filter(item => item.id !== address.id);
          this.isFormVisible = false;
          this.$toast.success(this.$t('userAddress.addressDeleted'));
        }
      });
    },
    handleAddressSaved(updatedAddress) {
      if(updatedAddress.order_id){
        const index = this.addresses.findIndex(address => address.order_id === updatedAddress.order_id);
        if(index !== -1) {
          updateAddress(this.addresses[index].order_id, updatedAddress).then(response => {
            console.log(response, 'address updateAddress');
            if(response.status === 200){
              this.loadAddresses();
              this.$toast.success(this.$t('userAddress.addressUpdated'));
            }
          });
        }
      }else{
        updatedAddress.order_id = this.addresses.length + 1;
        addAddress(updatedAddress).then(response => {
          console.log(response, 'address addAddress');
          if(response.status === 200){
            this.loadAddresses();
            this.$toast.success(this.$t('userAddress.addressUpdated'));
          }
        });
      }
      this.isFormVisible = false;
      this.curentAddress = null;
    }
  },
  mounted() {
    this.loadAddresses();
  },
};
</script>

<style scoped>
.address-container {
  /* Styles */
}
</style>
